import { render, staticRenderFns } from "./NetShopOthers.vue?vue&type=template&id=b4cc5e48&scoped=true"
import script from "./NetShopOthers.vue?vue&type=script&lang=js"
export * from "./NetShopOthers.vue?vue&type=script&lang=js"
import style0 from "./NetShopOthers.vue?vue&type=style&index=0&id=b4cc5e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cc5e48",
  null
  
)

export default component.exports